import React from "react";

/**
 * 3D colored icons sourced from Microsoft Fluent Emoji (CC BY 4.0).
 * Loaded via jsDelivr CDN so we don't bloat our bundle.
 */
const FLUENT = "https://cdn.jsdelivr.net/gh/microsoft/fluentui-emoji@main/assets";

const ICON_MAP = {
  members: `${FLUENT}/Busts%20in%20silhouette/3D/busts_in_silhouette_3d.png`,
  events: `${FLUENT}/Calendar/3D/calendar_3d.png`,
  documents: `${FLUENT}/Page%20facing%20up/3D/page_facing_up_3d.png`,
  recognizedLodges: `${FLUENT}/Globe%20with%20meridians/3D/globe_with_meridians_3d.png`,
  building: `${FLUENT}/Classical%20building/3D/classical_building_3d.png`,
  pin: `${FLUENT}/Round%20pushpin/3D/round_pushpin_3d.png`,
  moneyBag: `${FLUENT}/Money%20bag/3D/money_bag_3d.png`,
  checkMark: `${FLUENT}/Check%20mark%20button/3D/check_mark_button_3d.png`,
  hourglass: `${FLUENT}/Hourglass%20not%20done/3D/hourglass_not_done_3d.png`,
  warning: `${FLUENT}/Warning/3D/warning_3d.png`,
  crown: `${FLUENT}/Crown/3D/crown_3d.png`,
  hammer: `${FLUENT}/Hammer/3D/hammer_3d.png`,
  graduationCap: `${FLUENT}/Graduation%20cap/3D/graduation_cap_3d.png`,
  star: `${FLUENT}/Star/3D/star_3d.png`,
  person: `${FLUENT}/Bust%20in%20silhouette/3D/bust_in_silhouette_3d.png`,
};

export default function Icon3D({ name, size = 44, alt = "", style = {}, ...rest }) {
  const src = ICON_MAP[name];
  if (!src) return null;
  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      draggable={false}
      style={{
        width: size,
        height: size,
        objectFit: "contain",
        userSelect: "none",
        ...style,
      }}
      {...rest}
    />
  );
}
